import { Link } from "gatsby";
import React from "react";
import { FiCalendar } from "react-icons/fi";

interface CardBlogProps {
  slug: string;
  image: string;
  date: string;
  title: string;
}

const mes = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const CardBlog: React.FC<CardBlogProps> = ({ date, image, slug, title }) => {
  const dateConverted = new Date(date);

  return (
    <Link to={`/noticia/${slug}`}>
      <div className="card card-hover mb-4">
        <div className="card-image">
          <figure className="image is-4by3">
            <img src={image} alt="Placeholder image" loading="lazy" />
          </figure>
        </div>
        <div className="card-content" style={{ minHeight: 170 }}>
          <div className="content">
            <span className="tag is-primary is-light has-text-weight-bold mb-2">
              <FiCalendar className="mr-2" />
              {`${dateConverted.getDate()} de ${
                mes[dateConverted.getMonth()]
              } de ${dateConverted.getFullYear()}`}
            </span>
            <p className="title is-5">{title}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CardBlog;
